import React from 'react';
import { Input, InputNumber } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';

const { TextArea } = Input;

class MsgSetting extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { dispatch, onClose, intl, setData, params } = this.props;
    const { text, duration } = params;
    const allowSend = text !== '' && duration > 0;

    return (
      <div className="subtitles-container">
        <div className="subtitles-setting">
          <div className="setting-wrap">
            <span className="setting-label">
              <FormattedMessage id="cmma_msg_label1" />
              <span className="bi-tian">*</span>
            </span>
            <span className="setting-item">
              <InputNumber
                min={1}
                max={120}
                defaultValue={10}
                value={duration}
                className="duration-input"
                onChange={val => {
                  setData({ duration: val });
                }}
              />
            </span>
          </div>
          <div className="setting-wrap">
            <span className="setting-label">
              <FormattedMessage id="message_content" />
              <span className="bi-tian">*</span>
            </span>
            <span className="setting-item">
              <TextArea
                id="cmma-msg"
                placeholder={intl.formatMessage({ id: 'cmma_msg_empty' })}
                autosize={{ minRows: 3, maxRows: 6 }}
                value={text}
                onChange={() => {
                  const text = document.getElementById('cmma-msg').value;
                  text.length <= 60 && setData({ text });
                }}
              />
            </span>
          </div>
        </div>
        <div className="subtitles-footer">
          <div className="subtitles-btn" onClick={onClose}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
          <div
            className={`subtitles-btn ${allowSend ? '' : 'empty'}`}
            onClick={() => {
              if (allowSend) {
                dispatch({ type: 'meetingControl/sendSubtitles', params });
                onClose();
              }
            }}
          >
            <FormattedMessage id="index_send" />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(MsgSetting);



// WEBPACK FOOTER //
// ./src/components/MsgSetting.js